import type { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../../lib/helpers';

type SpaceSettingsSectionProps = {
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  additionalClasses?: string;
  testId?: string;
};

const SpaceSettingsSection = ({
  title,
  description,
  children,
  additionalClasses,
  testId,
}: SpaceSettingsSectionProps) => (
  <div
    className={twMerge(
      'rounded-lg bg-white dark:bg-slate-950 py-10.5 px-12',
      additionalClasses,
    )}
    {...getTestProps(testId, 'section')}
  >
    <div className="flex flex-col gap-4">
      <span className="text-2xl font-bold dark:text-slate-200">{title}</span>
      {description ? (
        <span className="dark:text-slate-200 whitespace-pre-wrap">
          {description}
        </span>
      ) : null}
    </div>

    {children}
  </div>
);

export default SpaceSettingsSection;
